/*
|--------------------------------------------------------------------------
| Paywall: MPP
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */
__gh__webApp.paywall.mpp = {
	"init": function(){
		var thisObject	= __gh__webApp.paywall;
			currentPage = __gh__webApp.currentPage;

		if (thisObject.isDisabled() || currentPage.isArticleExtLogin()) {return;}
		
		this.readSession({
			"callback": function(data){
				thisObject.toggleLoginLogoutText(data);
			}
		});
	},
	
	
	"doWallCloseModalCallback": function(){
		var currentPage = __gh__webApp.currentPage;
		if (currentPage.isHome()){ return; }
		document.location.href="/";
	},
	
	
	"doWall": function(type) {
		var thisObject		= __gh__webApp.paywall;
		if (thisObject.isDisabled()) { return; }
		
		var modal 			= __gh__webApp.utilities.modal,
			registerURL 	= "http://" + window.location.hostname + "/apps/pbcs.dll/misc?url=/misc/registerMini.pbs",
			subscribeURL 	= "http://" + window.location.hostname + "/apps/pbcs.dll/misc?url=/misc/subscribeMini.pbs",
			url	  			= (type=="Anonymous") ? registerURL : subscribeURL;

		modal.openModal({
			"url":url,
			"closeModalCallback":{
				"callback":"__gh__webApp.paywall.doWallCloseModalCallback"
			}
		});

	},
	
	
	"doWallOnTimer": function(data){
		var thisObject		= __gh__webApp.paywall;

		setTimeout(function(){
			thisObject.doWall(data.sessioninfo[0].c13);
		}, 3000);
	},
	
	
	"isDisabled": function(){
		return (__gh__coreData["3rdPartyData"].paywall.mpp.disabled);
	},
	
	
	"readSession": function(options){
		var thisObject		= __gh__webApp.paywall;
		if (thisObject.isDisabled()) { return; }

		var commonJS		= __gh__webApp.common,
			sessionURL	 	= "http://"+ window.location.hostname +"/apps/pbcs.dll/misc?url=/misc/sessioninfo.pbs&mime=application%2fjson",   // JSON Session Info
			callback		= ("callback" in options) ? options.callback : null,
			unixTime 		= Math.round(+new Date()/1000),
		    sessionURL 		= sessionURL + '&date=' + unixTime;

		$.getJSON(sessionURL, function(data) {
			if (!callback){ return; }
			
			commonJS.callFunction({
				"callback": callback,
				"data": data
			});
		});


	},
	
	
	
	"sessionBar": {
		
		/**
		 * Increment Total Premium Clicks
		 * Fetches the premium click data from the session
		 */
		"incrementTotalPremiumClicks": function(){
			var thisObject			= __gh__webApp.paywall;	
			
			thisObject.readSession({
				"callback": function(data){
					var $totalPremiumClicks = $("#paywall-bar-left .paywall-total-premium-clicks"),
						totalPremiumClicks 	= parseInt(data.sessioninfo[0].noofstoriesviewed);
					
					$totalPremiumClicks.html(totalPremiumClicks);
				}
			});
		}
	},
	
	
	"toggleLoginLogoutText": function(data){
		var loginText = $('#lmg-paywall-toggle span'),
			loginHref = $('#lmg-paywall-toggle');
		
		//Nav Login/Logout and eEdition Link
		if(data.sessioninfo[0].reguser != 1){
			//console.log('Anonymous User - Not logged in - show login link');
			return;
		}
		
		//console.log('User is logged in - show logout link');
		loginHref.attr("href", "/logout");
		loginText.text('Logout');
		
		//Registered Subscriber - Logged in
		/*if(data.sessioninfo[0].singlesale != 'Reguser'){
			console.log('LMG PAYWALL MSG for subscribe - show eEdition link');
		}*/

	},
	
	
	"goSub": function (zip, boxType) {
		var thisObject 		= __gh__webApp.paywall;
			returnUrl 		= escape(window.location.pathname + window.location.search),
			isZip			= thisObject.isZip(zip),
			registerURL1	= "/apps/pbcs.dll/misc?url=/static/premiumContent/initialOffer.html&zipcode=" + zip + "&step=2&returnurl=" + returnUrl + "&cid=obtregbox",
			registerURL2	= "/apps/pbcs.dll/misc?url=/static/premiumContent/initialOffer.html&step=2&returnurl=" + returnUrl + "&cid=obtregbox"
			registerURL 	= (isZip) ? registerURL1 : registerURL2,
			subscribeURL1	= "/apps/pbcs.dll/misc?url=/static/premiumContent/initialOffer.html&zipcode=" + zip + "&cid=obtsubbox",
			subscribeURL2	= "/apps/pbcs.dll/misc?url=/static/premiumContent/initialOffer.html&cid=obtsubbox"
			subscribeURL 	= (isZip) ? subscribeURL1 : subscribeURL2,
			url 		 	= (boxType == "reg") ? registerURL : null;
			url				= (!url && boxType == "sub") ? subscribeURL : url;
			
		if (!url) { return; }
		
		window.location.href = url;

	},
	
	
	/**
	 * Check for correct zip code
	 */
	"isZip": function(s) {
		var reZip = new RegExp(/(^\d{5,6}$)/);
		if (!reZip.test(s)) { return false; }
	 	return true;
	},
	
	
	"isUserLoggedIn": function(){
		try{
			var thisObject		= __gh__webApp.paywall;
			if (thisObject.isDisabled()) { return; }
			if(s_prop13 == 'PREMIUM01'){ return s_prop13; }
			return false;
		}
		catch(e){
			return false;
		}
		
	},
	"offerCallback":function(options){
		var commonJS					= __gh__webApp.common,
			showOfferCallbackObject 	= (options.showOfferCallbackObject) ? options.showOfferCallbackObject : null,
			noOfferCallbackObject	 	= (options.noOfferCallbackObject) ? options.noOfferCallbackObject : null,
			isDisabledCallbackObject 	= (options.isDisabledCallbackObject) ? options.isDisabledCallbackObject : null,
			isShowOffer					= __gh__coreData.pageData.isExtLogin;
	
		if (this.isDisabled()) {
			return (isDisabledCallbackObject) ? commonJS.callFunction(isDisabledCallbackObject) : false;
		}
		
		if (noOfferCallbackObject && !isShowOffer){	
			commonJS.callFunction(noOfferCallbackObject);		
		}
		
		
		if (showOfferCallbackObject && isShowOffer){				
			commonJS.callFunction(showOfferCallbackObject);
		}
		
	},
	
	"meterMainArticle": function(articleDOM,articleObject){},
	"meterReadMoreArticle": function(articleDOM,articleObject){},
	"refreshExperience": function(){},
	"refreshArticleExperience": function(articleObject){},
	"showUserLoginForm": function(){}
};